module.exports = __webpack_public_path__ + "static/media/ico-community.0e72e8b3.svg";